/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

/**
 * Refactoring operations
 */
export enum REFACTORING_OP {
	IDENTIFIER_RENAME = "identifierRename"
}

/**
 * Rename identifier refactoring operation object
 */
export interface IRefactoringEvent_IdentifierRename {
	operation: REFACTORING_OP.IDENTIFIER_RENAME;
	oldIdentifier: string;
	newIdentifier: string;
}

/**
 * Refactoring event
 */
export type TRefactoringEvent = IRefactoringEvent_IdentifierRename;
